import "./employeeCard.css"

type EmployeeCardProps = {
    name: string;
    role: string;
    education: string;
    phone: string;
    extension: string;
    email: string;
    fax: string;
};

export default function EmployeeCard({name, role, education, phone, email, extension, fax}: EmployeeCardProps) {
    return (
        <div className="employee-card">
            {name !== "" &&
                <h3>{name}</h3>
            }
            <p className="employee-role">{role}</p>

            {education !== "" &&
                <p className="employee-education">
                    <strong>Certified:</strong> {education}
                </p>
            }

            <p>
                <strong>Phone:</strong>{" "}
                <a href={`tel:${phone}`}>{phone}</a>{" "}
                {extension !== "" &&
                    <>
                        <strong>ext:</strong>{" "}{extension}
                    </>
                }
            </p>

            {fax !== "" &&
                <p className="employee-education">
                    <strong>Fax:</strong> {fax}
                </p>
            }

            <p>
                <strong>Email:</strong>{" "}
                <a href={`mailto:${email}`}>{email}</a>
            </p>
        </div>
    );
}
